import { ROUTE_TYPE } from "../enums/ROUTE_TYPE";
import { CABIN_CLASS } from "../enums/CABIN_CLASS";

export const CabinClassOptions = [
  {
    label: "Economy",
    value: CABIN_CLASS.ECONOMY,
  },
  {
    label: "Business",
    value: CABIN_CLASS.BUSINESS,
  },
  {
    label: "First Class",
    value: CABIN_CLASS.FIRST_CLASS,
  },
  {
    label: "Premium Economy",
    value: CABIN_CLASS.PREMIUM_ECONOMY,
  },
];

export const RouteTypeOptions = [
  {
    label: "One-Way",
    value: ROUTE_TYPE.ONEWAY,
  },
  {
    label: "Round-Trip",
    value: ROUTE_TYPE.RETURN,
  },
  {
    label: "Multi-City",
    value: ROUTE_TYPE.MULTI_CITY,
  },
];

export const CACHE_NAMES = {
  balance: "AeroglobePortal_v1_balance",
  flightsBookings: "AeroglobePortal_flights_bookings",
  hotelsBookings: "AeroglobePortal_hotels_bookings",
  toursBookings: "AeroglobePortal_tours_bookings",
};
